import FetchOptionChain from "../Apis/FetchOptionChain";
import FetchOptionChainPrices from "../Apis/FetchOptionChainPrices";
import { resetAllDashboards } from "./selectionActions";

export const setOptionsData = (data, portfolioId, detailsHash) => ({
  type: "SET_OPTIONS_DATA",
  payload: { data, portfolioId, detailsHash },
});

export const setLoading = (isLoading) => ({
  type: "SET_LOADING",
  payload: isLoading,
});

export const setError = (error) => ({
  type: "SET_ERROR",
  payload: error,
});

const calculateTotalPremiumAndCost = (closestOptions, portfolioData) => {
  let totalPremium = 0;
  let totalCost = 0;

  Object.entries(closestOptions.calls).forEach(([ticker, callOption]) => {
    const bidPrice = parseFloat(callOption.CloseBidPrice);
    const portfolioItem = portfolioData.find((item) => item.ticker === ticker);
    const quantityMultiplier = portfolioItem
      ? Math.floor(portfolioItem.quantity / 100)
      : 0;
    totalPremium += bidPrice * quantityMultiplier * 100;
  });

  // Object.entries(closestOptions.puts).forEach(([ticker, putOption]) => {
  //   const askPrice = parseFloat(putOption.CloseAskPrice);
  //   const portfolioItem = portfolioData.find(item => item.ticker === ticker);
  //   const quantityMultiplier = portfolioItem ? Math.floor(portfolioItem.quantity / 100) : 0;
  //   totalCost += (askPrice * quantityMultiplier * 100);
  // });
  sessionStorage.setItem("totalPremium", JSON.stringify(totalPremium));
  sessionStorage.setItem("totalCost", JSON.stringify(totalCost));
};

function chunkArray(array, size) {
  const chunkedArray = [];
  for (let i = 0; i < array.length; i += size) {
    chunkedArray.push(array.slice(i, i + size));
  }
  return chunkedArray;
}

const getDynamicTickerChunkSize = (tickerCount) => {
  if (tickerCount <= 5) {
    return 1;
  }
  if (tickerCount <= 15) {
    return 2;
  }
  if (tickerCount <= 35) {
    return 3;
  }
  if (tickerCount <= 70) {
    return 4;
  }
  return 5;
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mergePricedData = (targetData, sourceData) => {
  ["C", "P"].forEach((type) => {
    Object.keys(sourceData?.[type] || {}).forEach((stock) => {
      if (!targetData[type][stock]) {
        targetData[type][stock] = [];
      }
      targetData[type][stock].push(...sourceData[type][stock]);
    });
  });
};

const buildOptionDataChunk = (optionsData, tickers) =>
  tickers.reduce((accumulator, ticker) => {
    accumulator[ticker] = optionsData[ticker];
    return accumulator;
  }, {});

const fetchPriceChunkWithFallback = async ({
  optionsData,
  tickers,
  singleTickerRetryCount = 0,
}) => {
  try {
    const optionDataChunk = buildOptionDataChunk(optionsData, tickers);
    return await FetchOptionChainPrices(optionDataChunk);
  } catch (error) {
    if (tickers.length > 1) {
      const splitIndex = Math.ceil(tickers.length / 2);
      const leftTickers = tickers.slice(0, splitIndex);
      const rightTickers = tickers.slice(splitIndex);

      const [leftChunkData, rightChunkData] = await Promise.all([
        fetchPriceChunkWithFallback({ optionsData, tickers: leftTickers }),
        fetchPriceChunkWithFallback({ optionsData, tickers: rightTickers }),
      ]);

      const mergedData = { C: {}, P: {} };
      mergePricedData(mergedData, leftChunkData);
      mergePricedData(mergedData, rightChunkData);
      return mergedData;
    }

    if (singleTickerRetryCount < 2) {
      await wait(1500 * (singleTickerRetryCount + 1));
      return fetchPriceChunkWithFallback({
        optionsData,
        tickers,
        singleTickerRetryCount: singleTickerRetryCount + 1,
      });
    }

    throw error;
  }
};

const parseDate = (dateStr) => new Date(dateStr);

export const fetchOptionsDataIfNeeded =
  (portfolioData, portfolioId) => async (dispatch, getState) => {
    console.log(" in fetch option", portfolioData);
    const { options } = getState();
    console.log(" in fetch options.isLoadi", options.isLoading);
    const detailsHash = JSON.stringify(portfolioData);

    if (!options.isLoading) {
      console.log(" in fetch options.isLoadiinn", !options.isLoading);
      dispatch(resetAllDashboards());

      const storedOptimizerPortfolioId = parseInt(
        sessionStorage.getItem("optimizerPortfolioId"),
      );
      const isSamePortfolio = storedOptimizerPortfolioId === portfolioId;
      console.log(
        "storedOptimizerPortfolioId",
        storedOptimizerPortfolioId,
        portfolioId,
        isSamePortfolio,
      );
      // If different portfolio, clear optimizer data
      if (!isSamePortfolio) {
        sessionStorage.removeItem("optimizerData");
        sessionStorage.removeItem("optimizedPremium");
        sessionStorage.removeItem("optimizerPortfolioId");
      }
      sessionStorage.removeItem("callWritingCartItems");
      sessionStorage.removeItem("putBuyingCartItems");
      sessionStorage.removeItem("existingOptionHoldings");
      sessionStorage.removeItem("selectedRecommendations");
      dispatch(setLoading(true));
      const portfolioChunks = chunkArray(portfolioData, 100);
      console.log("portfolioData", portfolioData);
      console.log("portfolioChunks", portfolioChunks);

      let combinedPricedData = {
        C: {},
        P: {},
      };

      await Promise.allSettled(
        portfolioChunks.map(async (chunk) => {
          try {
            // const optionsData = await FetchOptionChain(chunk);
            // console.log("optionsData", optionsData)
            // const pricedData = await FetchOptionChainPrices(optionsData).catch(err => {
            //   console.error("Error fetching prices for options data:", err);
            //   return { C: {}, P: {} }; // Return empty structure in case of error
            // });

            const optionsData = await FetchOptionChain(chunk);
            const tickerList = Object.keys(optionsData);
            const chunkSize = getDynamicTickerChunkSize(tickerList.length);
            const tickerBatches = chunkArray(tickerList, chunkSize);
            const requestConcurrency = tickerList.length <= 15 ? 3 : 4;
            const requestBatches = chunkArray(
              tickerBatches,
              requestConcurrency,
            );

            for (const requestBatch of requestBatches) {
              const tickerPriceResults = await Promise.allSettled(
                requestBatch.map((tickerBatch) =>
                  fetchPriceChunkWithFallback({
                    optionsData,
                    tickers: tickerBatch,
                  }),
                ),
              );

              tickerPriceResults.forEach((result) => {
                if (result.status === "rejected") {
                  console.error(
                    "Error fetching prices for options data:",
                    result.reason,
                  );
                  dispatch(
                    setError(result.reason?.toString?.() || "Unknown error"),
                  );
                  return;
                }

                mergePricedData(combinedPricedData, result.value);
              });
            }
          } catch (error) {
            console.error("Error fetching options data:", error);
          }
        }),
      );

      console.log("combinedPricedData", combinedPricedData, portfolioData);

      const findClosestOption = (
        options,
        oneMonthFromNow,
        targetMultiplier,
      ) => {
        let bestOption = null;
        // const targetDate = parseDate(oneMonthFromNow);
        //subtract 1 day from one month from now
        const targetDate = new Date(oneMonthFromNow - 1);
        const sortedOptions = options.sort((a, b) => {
          const dateDiffA = Math.abs(parseDate(a.ExpirationDate) - targetDate);
          const dateDiffB = Math.abs(parseDate(b.ExpirationDate) - targetDate);

          if (dateDiffA !== dateDiffB) {
            return dateDiffA - dateDiffB;
          } else {
            const strikeDiffA = Math.abs(
              a.Strike - a.ClosePrice * targetMultiplier,
            );
            const strikeDiffB = Math.abs(
              b.Strike - b.ClosePrice * targetMultiplier,
            );
            return strikeDiffA - strikeDiffB;
          }
        });
        bestOption = sortedOptions[0];
        return bestOption;
      };

      const processOptions = (optionsData, isCall) => {
        const oneMonthFromNow = new Date();
        oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

        const targetMultiplier = isCall ? 1.1 : 0.9;

        return Object.keys(optionsData).reduce((acc, ticker) => {
          const options = optionsData[ticker];
          const closestOption = findClosestOption(
            options,
            oneMonthFromNow,
            targetMultiplier,
          );
          if (closestOption) {
            acc[ticker] = closestOption;
          }
          console.log("acc", acc);
          return acc;
        }, {});
      };

      // Process calls and puts with the updated logic
      const closestOptions = {
        calls: processOptions(combinedPricedData.C, true),
        puts: processOptions(combinedPricedData.P, false),
      };

      calculateTotalPremiumAndCost(closestOptions, portfolioData);

      try {
        // Dispatch the combinedPricedData with its structure preserved
        dispatch(setOptionsData(combinedPricedData, portfolioId, detailsHash));
      } catch (dispatchError) {
        console.error("Error dispatching priced options data:", dispatchError);
        dispatch(setError(dispatchError.toString()));
      } finally {
        dispatch(resetAllDashboards());
        dispatch(setLoading(false));
      }
    }
  };
